import {useDispatch, useSelector} from "react-redux";
import { useCallback, useEffect } from "react";
import {isNullOrEmpty} from "../../utils/isNullOrEmpty";
import {updateModalContent} from "../../features/openInModal/OpenInModalSlice";
import {getTableAndFigureContent} from "./openInModal";

export function useOpenInModalRender(rootRef) {
  const sectionId = useSelector((state) => state.openInModal.sectionId);
  const dispatch = useDispatch();

  const extractContent = useCallback(() => {
    const root = rootRef.current;
    if (root && !isNullOrEmpty(sectionId)) {
      const htmlString = getTableAndFigureContent(root, sectionId);
      dispatch(updateModalContent(htmlString));
    }
  }, [rootRef, sectionId, dispatch]);

  useEffect(() => {
    if (!rootRef?.current) return;
    extractContent();
  }, [extractContent]);
}